<div class="col-12 col-lg-8 offset-lg-2 my-3" style=" min-height: 500px;">
  <div class="d-flex flex-column pt-5">
    <div class="d-inline-flex justify-content-center py-2">
      <!--<img class="start-ke-qr" src="assets/resource/ke-qr.png" width="250" height="250">-->
      <img class="start-ke-qr"  width="250" height="250">
    </div>
    <div class="d-inline-flex justify-content-center py-2">
      <strong>{{'g.download-mobile-app'|translate}}</strong>
    </div>
    <div class="d-inline-flex flex-row justify-content-center">
      <a href="https://play.google.com/store/apps/details?id=kerry.express.th.mobile.tracking&amp;hl=th" class="mr-2"
        target="_blank">

        <img src="assets/resource/google-play.png" width="150">
      </a>

      <a href="https://itunes.apple.com/th/app/kerry-express/id909585896?l=th&amp;mt=8" target="_blank"
        class="icon ios">

        <img src="assets/resource/apple-store.png" width="150">
      </a>

    </div>
  </div>
</div>
